import { AppConfigModel } from "../abstract/app-config.model";

export class TaxationRegime extends AppConfigModel {

    static override CLASS_NAME: string = 'TaxationRegime';
}
